import Action from 'actions';
import ArrayHelper, {groupObjectsByProp} from 'helpers/array-helper';
import Const from 'constants';
import {LpClassic as BaseLP} from 'services/sports/mlb/lp/lp-classic';
import {preparePlayerUID} from 'helpers/player-helper';
import {getSimplexUnitName} from 'helpers/simplex-helper';

export default class LpClassic extends BaseLP {
    minTeams({incomingValues = {}}) {
        const {
            playersData: {preparedPlayers},
            sportConfig,
        } = Action.getState();
        const players = preparedPlayers.groupedBy.allowedPositions();
        const teams = groupObjectsByProp(players, 'team');
        const teamRows = {};
        const couples = {};
        const maxPlayersInTeam = sportConfig.getConfigProp('playersInTeam') - 1;
        const minTeams = Number(sportConfig.getConfigProp('minTeams'));

        let result = '';

        Object.keys(teams).map((teamName) => {
            let players = teams[teamName],
                addedPlayers = [];
            teamRows[teamName] = '';
            players.map((player) => {
                if (!inArray(player.uniqueId, addedPlayers)) {
                    teamRows[teamName] += '+' + getSimplexUnitName(player.uniqueId);
                    addedPlayers.push(player.uniqueId);
                }
            });
        });

        if (ArrayHelper.countItems(teams) > minTeams) {
            Object.keys(teamRows).map((tn1) => {
                Object.keys(teamRows).map((tn2) => {
                    if (tn1 !== tn2) {
                        let combi1 = tn1 + tn2,
                            combi2 = tn2 + tn1;
                        if (!couples.hasOwnProperty(combi1) && !couples.hasOwnProperty(combi2)) {
                            couples[combi1] = teamRows[tn1] + teamRows[tn2];
                        }
                    }
                });
            });
            Object.keys(couples).map((key) => {
                result += couples[key] + '<=' + maxPlayersInTeam + '\n';
            });
        } else {
            Object.keys(teamRows).map((key) => {
                result += teamRows[key] + '>=1\n';
            });
        }
        // console.log('minTeams',result);
        return result;
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {checkIfPlayerOnDoublePosition: true}, ''),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {checkIfPlayerOnDoublePosition: true}, ''),
            positions: this.exec('positions', {unitIdPropName: 'uniqueId'}, ''),
            teams: this.exec('team', {}, ''),
            limitPositions: this.exec('limitPositions', {}, ''),
            minTeams: this.exec('minTeams', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {checkIfPlayerOnDoublePosition: true}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec('playersWhoseGamesAreLocked', {checkIfPlayerOnDoublePosition: true, unitIdPropName: 'uniqueId'}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            multiPositions: this.exec('prepareSectionByMultiPositions', {}, ''),
            hitterStacks: this.exec('prepareSectionByHittersStack', {}, ''),
            nonControlledHittersStacking: this.exec('nonControlledHittersStacking', {getUnitIdsByPlayer: (player) => preparePlayerUID(player)}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            teamExposureMax: this.exec('teamExposureMax', {minPlayersQuantityToIdentifyUsedTeam: Const.MLB_MIN_PLAYERS_QUANTITY_TO_IDENTIFY_USED_TEAM}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {checkIfPlayerOnDoublePosition: true}, ''),
        };

        return {...constraints};
    }
}
